/**
 * Detects if the current browser is Safari
 * Note: This checks for Safari specifically, not Chrome on iOS or other WebKit browsers
 */
export function isSafari(): boolean {
  if (typeof window === "undefined") return false;

  const ua = window.navigator.userAgent;
  const vendor = window.navigator.vendor;

  // Safari has "Safari" in UA and "Apple Computer" as vendor
  // But Chrome also has "Safari" in UA, so we need to exclude it
  const isSafariBrowser =
    vendor.includes("Apple") &&
    ua.includes("Safari") &&
    !ua.includes("Chrome") &&
    !ua.includes("CriOS"); // Chrome on iOS

  return isSafariBrowser;
}

/**
 * Detects if the current browser is Firefox
 */
export function isFirefox(): boolean {
  if (typeof window === "undefined") return false;

  const ua = window.navigator.userAgent;
  return ua.includes("Firefox");
}

/**
 * Detects if screenshot feature should be hidden
 * Currently hidden on Safari and Firefox due to html2canvas limitations
 */
export function shouldHideScreenshot(): boolean {
  return isSafari() || isFirefox();
}
